"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5589],{

/***/ 15589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ chat_ChatRoomList; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./hooks/query/useOutlook.ts
var useOutlook = __webpack_require__(48049);
// EXTERNAL MODULE: ./hooks/useMounted.ts
var useMounted = __webpack_require__(38464);
// EXTERNAL MODULE: ./hooks/useScrollPosition.ts
var useScrollPosition = __webpack_require__(80786);
// EXTERNAL MODULE: ./.yarn/cache/@sentry-core-npm-7.83.0-bdefa83536-dd27382da7.zip/node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(41755);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./components/common/Adfit.tsx
var Adfit = __webpack_require__(15822);
// EXTERNAL MODULE: ./components/common/NativeInFeedAd.tsx
var NativeInFeedAd = __webpack_require__(80521);
// EXTERNAL MODULE: ./components/common/BottomButton.tsx
var BottomButton = __webpack_require__(1035);
// EXTERNAL MODULE: ./components/common/Empty.tsx
var Empty = __webpack_require__(34270);
// EXTERNAL MODULE: ./components/common/HorizontalFilter.tsx
var HorizontalFilter = __webpack_require__(61507);
// EXTERNAL MODULE: ./components/common/ListItem.tsx
var ListItem = __webpack_require__(92626);
// EXTERNAL MODULE: ./components/common/Loading.tsx
var Loading = __webpack_require__(30208);
// EXTERNAL MODULE: ./components/common/Pagination.tsx
var Pagination = __webpack_require__(39753);
// EXTERNAL MODULE: ./components/layout/Push.tsx
var Push = __webpack_require__(23516);
// EXTERNAL MODULE: ./components/outlook/OutlookComponent.tsx + 14 modules
var OutlookComponent = __webpack_require__(3455);
// EXTERNAL MODULE: ./api/chatbot.ts
var chatbot = __webpack_require__(23082);
// EXTERNAL MODULE: ./constants/index.ts + 1 modules
var constants = __webpack_require__(60186);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/chat.ts
var chat = __webpack_require__(42127);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
// EXTERNAL MODULE: ./utils/localStorage.ts
var localStorage = __webpack_require__(48163);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./utils/query.ts
var utils_query = __webpack_require__(96261);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
// EXTERNAL MODULE: ./components/chat/ChatRoom.tsx
var ChatRoom = __webpack_require__(81087);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./components/common/Badge.tsx
var Badge = __webpack_require__(63732);
// EXTERNAL MODULE: ./components/common/RoundAvatar.tsx
var RoundAvatar = __webpack_require__(81794);
// EXTERNAL MODULE: ./utils/date.ts + 31 modules
var date = __webpack_require__(9987);
;// CONCATENATED MODULE: ./components/chat/StoryChatRoomCard.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    padding: ",
        "px ",
        "px ",
        "px\n      ",
        "px;\n    height: 68px;\n    ",
        ";\n    ",
        ";\n    color: ",
        ";\n    overflow: visible;\n    position: relative;\n\n    ",
        " {\n      padding: ",
        "px ",
        "px ",
        "px\n        ",
        "px;\n    }\n\n    ",
        " {\n      padding: ",
        "px ",
        "px ",
        "px\n        ",
        "px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: ",
        ";\n    margin-left: ",
        "px;\n    width: 100%;\n    justify-content: ",
        ";\n    ",
        ";\n\n    p {\n      ",
        ";\n      color: ",
        ";\n      line-height: 135%;\n    }\n\n    .date {\n      text-align: end;\n      width: 70px;\n      min-width: 70px;\n      max-width: 70px;\n    }\n\n    .character-name {\n      display: flex;\n      text-align: left;\n      align-item: center;\n      line-height: 135%;\n      gap: ",
        "px;\n\n      .new-badge {\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    .last-message {\n      text-align: left;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  text-align: center;\n  justify-content: space-between;\n\n  h5 {\n    ",
        ";\n    align-self: start;\n    line-height: 100%;\n  }\n\n  .character-name {\n    display: flex;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n  align-self: start;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  top: 50%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: 6px;\n  gap: 10px;\n\n  .story-container,\n  .balloon-container {\n    display: flex;\n    flex-direction: row;\n    gap: 2px;\n    align-items: center;\n    text-align: center;\n\n    & p {\n      ",
        ";\n    }\n\n    .story {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var chatRoomCSS = function(isBorder) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, isBorder ? "border: 1px solid ".concat(theme.colors.main500) : null, isBorder ? "border-radius: 5px" : null, theme.var.gray900, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xlarge */.Ki.xlarge, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xxlarge */.Ki.xxlarge);
    };
};
var chatRoomHeaderCSS = function(isEdit) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject1(), isEdit ? "row" : "column", dist_esm/* Spacing.medium */.Ki.medium, isEdit ? "space-between" : "center", isEdit ? "align-items: center" : "null", dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray500, dist_esm/* Spacing.xhsmall */.Ki.xhsmall);
    };
};
var chatRoomTopHeaderCSS = (0,emotion_react_browser_esm.css)(_templateObject2(), dist_esm/* Typography.h5 */.ZT.h5);
var chatRoomBottomHeaderCSS = (0,emotion_react_browser_esm.css)(_templateObject3(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
var storySelecButtonCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject4(), theme.var.black);
};
var statCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject5(), dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray400);
};
var StoryChatRoomCard = function(param) {
    var chatRoomInfo = param.chatRoomInfo, _isEdit = param.isEdit, isEdit = _isEdit === void 0 ? false : _isEdit, _isCheck = param.isCheck, isCheck = _isCheck === void 0 ? false : _isCheck, _isBorder = param.isBorder, isBorder = _isBorder === void 0 ? false : _isBorder, right = param.right, onClickAvatar = param.onClickAvatar, story = param.story, _isNewCharacter = param.isNewCharacter, isNewCharacter = _isNewCharacter === void 0 ? false : _isNewCharacter;
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var getFormattedDate = function(lastMessageDate) {
        var koreanDate = new Date(lastMessageDate);
        var currentKoreanDate = new Date();
        var currentKoreanDateOnly = new Date(currentKoreanDate.setHours(0, 0, 0, 0));
        var koreanDateOnly = new Date(koreanDate.setHours(0, 0, 0, 0));
        var diff = (0,date/* differenceInDays */.jc)(currentKoreanDateOnly, koreanDateOnly);
        if (diff < 1) {
            return (0,date/* formatDate */.p6)(lastMessageDate, "a h:mm");
        } else if (diff >= 1 && diff < 2) {
            return "어제";
        } else {
            return "".concat(diff, "일 전");
        }
    };
    var ref;
    var lastMessageDate = (ref = chatRoomInfo === null || chatRoomInfo === void 0 ? void 0 : chatRoomInfo.lastMessageDate) !== null && ref !== void 0 ? ref : "";
    var parsedLastMessageDate = getFormattedDate(lastMessageDate);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
            css: chatRoomCSS(isBorder),
            className: "chat-room-container",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    onClick: function() {
                        return onClickAvatar ? onClickAvatar() : null;
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RoundAvatar/* default */.Z, {
                        size: 44,
                        picture: chatRoomInfo.image
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    css: chatRoomHeaderCSS(!!isEdit || !!right),
                    className: "chat-room-header",
                    children: [
                        !right && !isEdit && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            onClick: function() {
                                return onClickAvatar ? onClickAvatar() : null;
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    css: chatRoomTopHeaderCSS,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                            className: "character-name",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                                                    children: t("{{characterName}}", {
                                                        characterName: chatRoomInfo.characterName
                                                    })
                                                }),
                                                isNewCharacter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, {
                                                    text: "새 캐릭터 등장 \uD83D\uDC40",
                                                    backgroundColor: "linear-gradient(90deg, #04C8D0, #1590D5)",
                                                    fontSize: 10,
                                                    className: "new-badge"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                            className: "date",
                                            children: t("{{lastMessageDate}}", {
                                                lastMessageDate: parsedLastMessageDate
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    css: chatRoomBottomHeaderCSS,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                        className: "last-message",
                                        children: t("{{lastMessage}}", {
                                            lastMessage: chatRoomInfo.lastMessage
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: "stat-container",
                                    css: statCSS,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                        className: "story-container",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                            className: "story",
                                            children: t(story ? "\uD83D\uDCD6 ".concat(story === null || story === void 0 ? void 0 : story.title) : "비공개 또는 삭제된 작품")
                                        })
                                    })
                                })
                            ]
                        }),
                        (isEdit || right) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    onClick: function() {
                                        return onClickAvatar ? onClickAvatar() : null;
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            css: chatRoomTopHeaderCSS,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                                className: "character-name",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                                                        children: t("{{characterName}}", {
                                                            characterName: chatRoomInfo.characterName
                                                        })
                                                    }),
                                                    isNewCharacter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, {
                                                        text: "새 캐릭터 등장 \uD83D\uDC40",
                                                        backgroundColor: "linear-gradient(90deg, #04C8D0, #1590D5)",
                                                        fontSize: 10,
                                                        className: "new-badge"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            css: chatRoomBottomHeaderCSS,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                className: "last-message",
                                                children: t("{{lastMessage}}", {
                                                    lastMessage: chatRoomInfo.lastMessage
                                                })
                                            })
                                        })
                                    ]
                                }),
                                right !== null && right !== void 0 ? right : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                    css: storySelecButtonCSS,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                        icon: icon/* CheckCircle */.fU,
                                        size: dist_esm/* Sizes.large */.u8.large,
                                        color: isCheck ? theme.colors.main500 : theme.var.gray200
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var chat_StoryChatRoomCard = (StoryChatRoomCard);

;// CONCATENATED MODULE: ./components/chat/ChatRoomList.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function ChatRoomList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function ChatRoomList_templateObject() {
    var data = ChatRoomList_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  text-align: left;\n  padding: ",
        "px ",
        "px;\n  border-bottom: 1px solid ",
        ";\n  ",
        ";\n  z-index: 3;\n  background-color: ",
        ";\n  height: 43px;\n\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n  .sort-container {\n    margin-left: ",
        "px;\n  }\n\n  ",
        " {\n    padding: ",
        "px ",
        "px;\n  }\n\n  ",
        " {\n    padding: ",
        "px ",
        "px;\n  }\n"
    ]);
    ChatRoomList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChatRoomList_templateObject1() {
    var data = ChatRoomList_taggedTemplateLiteral([
        "\n  margin-left: auto;\n\n  span {\n    display: inline-block;\n    height: 12px;\n    border-left: 1px solid ",
        ";\n    margin: 0 ",
        "px;\n    vertical-align: middle;\n  }\n"
    ]);
    ChatRoomList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ChatRoomList_templateObject2() {
    var data = ChatRoomList_taggedTemplateLiteral([
        "\n  font-size: ",
        "px;\n  color: ",
        ";\n"
    ]);
    ChatRoomList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ChatRoomList_templateObject3() {
    var data = ChatRoomList_taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n\n  li {\n    border-bottom: none;\n  }\n\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n"
    ]);
    ChatRoomList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ChatRoomList_templateObject4() {
    var data = ChatRoomList_taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n"
    ]);
    ChatRoomList_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ChatRoomList_templateObject5() {
    var data = ChatRoomList_taggedTemplateLiteral([
        "\n  .empty {\n    ",
        ";\n  }\n\n  .outlook-container {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        "px;\n    padding: 0 0 0 ",
        "px;\n    margin-top: 10px;\n  }\n"
    ]);
    ChatRoomList_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = ChatRoomList_taggedTemplateLiteral([
        "\n  .bottomButton {\n    ",
        "\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


































var readStoryFilterCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ChatRoomList_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, theme.border.light, (0,css/* sticky */.CA)(Push/* PushSize.tab */.z.tab), theme.var.white, dist_esm/* Spacing.xsmall */.Ki.xsmall, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xxlarge */.Ki.xxlarge);
};
var editButtonGroupCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ChatRoomList_templateObject1(), theme.border.light, dist_esm/* Spacing.xsmall */.Ki.xsmall);
};
var editButtonCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ChatRoomList_templateObject2(), dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.black);
};
var chatRoomListContainerCSS = (0,emotion_react_browser_esm.css)(ChatRoomList_templateObject3(), dist_esm/* Spacing.xhsmall */.Ki.xhsmall, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge);
// const bannerCSS = (theme: Theme) => css`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 12px 14px;
//   color: ${theme.var.white};
//   background: ${SUBSCRIPTION_GRADIENT_COLOR};
//   p {
//     ${Typography.h6}
//     display: flex;
//     justify-content: center;
//     flex: 1;
//     font-size: 12px;
//     text-align: center;
//   }
// `;
var chatRoomListCss = (0,emotion_react_browser_esm.css)(ChatRoomList_templateObject4(), dist_esm/* Spacing.small */.Ki.small);
var emptyCSS = function(sort) {
    return (0,emotion_react_browser_esm.css)(ChatRoomList_templateObject5(), sort === "character" ? "padding: 0" : "", dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
};
var bottomBtnCSS = function(isCheming) {
    return (0,emotion_react_browser_esm.css)(_templateObject6(), isCheming ? "margin-bottom: 55px;" : "");
};
var ChatRoomList = function(param) {
    var _isAd = param.isAd, isAd = _isAd === void 0 ? true : _isAd, _hasEditBtn = param.hasEditBtn, hasEditBtn = _hasEditBtn === void 0 ? true : _hasEditBtn, characterId = param.characterId, onOccureClickChatRoom = param.onOccureClickChatRoom, _isCheming = param.isCheming, isCheming = _isCheming === void 0 ? false : _isCheming;
    var ref, ref1, ref2;
    var t = (0,esm/* useTranslation */.$G)().t;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var ref3 = (0,es.useMutation)(chatbot/* updateChatRoomsState */.nd), updateChatRooms = ref3.mutateAsync;
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var ref4 = (0,react.useState)(false), isSelectAll = ref4[0], setIsSelectAll = ref4[1];
    var ref5 = (0,react.useState)(false), isEdit = ref5[0], setIsEdit = ref5[1];
    var ref6 = (0,react.useState)([]), ids = ref6[0], setIds = ref6[1];
    var ref7 = (0,react.useState)([]), selectedIds = ref7[0], setSelectedIds = ref7[1];
    var ref8 = (0,react.useState)(false), isLoading = ref8[0], setIsLoading = ref8[1];
    var ref9 = (0,react.useState)("character"), sort = ref9[0], setSort = ref9[1];
    var ref10 = (0,react.useState)([]), storyIds = ref10[0], setStoryIds = ref10[1];
    // const isOverVersion =
    //   platform !== Platform.ios &&
    //   checkRequiredAppVersion(platform, version, SUBSCIRBE_VERSION);
    var chatRoomsQueries = {
        ordering: "last_chat_newest",
        status: "AT",
        character_id: characterId
    };
    if (characterId) {
        chatRoomsQueries.character_id = characterId;
    }
    var queryKey = characterId ? constants/* QUERY_KEYS.CHAT_ROOM.ACTIVE_CHARACTER_PAGINATION */.U7.CHAT_ROOM.ACTIVE_CHARACTER_PAGINATION(characterId) : constants/* QUERY_KEYS.CHAT_ROOM.LIST */.U7.CHAT_ROOM.LIST("Library");
    var storyQueryKey = constants/* QUERY_KEYS.CHAT_ROOM.STORY_LIST */.U7.CHAT_ROOM.STORY_LIST;
    var isMounted = (0,useMounted/* useMounted */.s)();
    var query = (0,utils_query/* useChatPaginationQuery */.aI)(queryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,chatbot/* fetchChatRooms */.PL)(chatRoomsQueries, pageParam);
    }, {
        refetchOnWindowFocus: "always",
        enabled: !!isMounted && sort === "character",
        onSuccess: function onSuccess(data) {
            var pages = data.pages;
            if (pages && isMounted) {
                var fetchedIds = pages === null || pages === void 0 ? void 0 : pages.map(function(page) {
                    var ref;
                    return (ref = page.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        return item.id;
                    });
                });
                setIds(fetchedIds === null || fetchedIds === void 0 ? void 0 : fetchedIds.flat());
                setIsSelectAll(false);
            }
        }
    });
    var storyQuery = (0,utils_query/* useChatPaginationQuery */.aI)(storyQueryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,chatbot/* fetchStoryChatRooms */.Ad)(pageParam);
    }, {
        enabled: !!isMounted && sort === "story" && !isCheming,
        refetchOnWindowFocus: "always",
        onSuccess: function onSuccess(data) {
            var pages = data.pages;
            if (pages && isMounted) {
                var fetchedIds = pages === null || pages === void 0 ? void 0 : pages.map(function(page) {
                    var ref;
                    return (ref = page.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        return item.id;
                    });
                });
                setStoryIds(fetchedIds === null || fetchedIds === void 0 ? void 0 : fetchedIds.flat());
                setIsSelectAll(false);
            }
        }
    });
    var hideInFeedAd = (0,misc/* isEnv */.h5)("production") || (0,misc/* isEnv */.h5)("staging");
    var inFeedAd = hideInFeedAd ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NativeInFeedAd/* default */.Z, {
        unitKey: "library_mobile"
    });
    (0,useScrollPosition/* useScrollPosition */.R)("chatList");
    var isQueryDataEmpty = query ? query.isFetched && query.count === 0 : false;
    var usePageOutlook = (0,useOutlook/* useOutlook */.p)().usePageOutlook;
    var outlook = usePageOutlook("library-play", {
        enabled: isQueryDataEmpty
    });
    var queryClient = (0,es.useQueryClient)();
    var web = (0,webview/* useWebView */.B9)().web;
    var router = (0,next_router.useRouter)();
    var ref11 = (0,hook/* useMe */.Pi)(), me = ref11.data;
    var handleShouldRefreshChange = function(event) {
        if (event.key === "shouldRefresh") {
            if (event.newValue === "true") {
                localStorage/* ParsedStorage.setItem */.f.setItem("shouldRefresh", "false");
                queryClient.invalidateQueries(constants/* QUERY_KEYS.USER.SOCIAL_PROVIDER */.U7.USER.SOCIAL_PROVIDER);
            }
        }
    };
    var handleClickContinuteButton = function() {
        var _ref = _asyncToGenerator(function(chatRoomId, storyId, episodeId, title) {
            var res;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (sort === "story") {
                            if (!storyId || !episodeId) {
                                return [
                                    2,
                                    alert("접근할 수 없는 채팅방입니다")
                                ];
                            }
                            if (platform === constants/* Platform.web */.t4.web) {
                                router.push("/stories/".concat(storyId, "/episodes/").concat(episodeId, "/chat-rooms/").concat(chatRoomId, "?mode=continue").concat(title ? "&title=".concat(title) : ""));
                            } else {
                                web.openPage("/stories/".concat(storyId, "/episodes/").concat(episodeId, "/chat-rooms/").concat(chatRoomId, "?mode=continue").concat(title ? "&title=".concat(title) : ""));
                            }
                            return [
                                2
                            ];
                        }
                        setIsLoading(true);
                        return [
                            4,
                            queryClient.fetchQuery(constants/* QUERY_KEYS.CHAT_ROOM.DETAIL */.U7.CHAT_ROOM.DETAIL(chatRoomId), /*#__PURE__*/ _asyncToGenerator(function() {
                                return __generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                (0,chatbot/* fetchChatRoomDetail */.pH)(chatRoomId)
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            }))
                        ];
                    case 1:
                        res = _state.sent();
                        if (res && me) {
                            setIsLoading(false);
                            if (onOccureClickChatRoom) {
                                onOccureClickChatRoom(chatRoomId);
                            }
                            setTimeout(function() {
                                if (platform === constants/* Platform.web */.t4.web) {
                                    router.push("/play/chat-rooms/".concat(res.id, "?mode=continue"));
                                } else {
                                    web.openPage("/play/chat-rooms/".concat(res.id, "?mode=continue"));
                                }
                            }, 300);
                        }
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickContinuteButton(chatRoomId, storyId, episodeId, title) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSelect = function(id) {
        var isCheck = selectedIds.includes(id);
        if (!isCheck) {
            setSelectedIds(function(prev) {
                return _toConsumableArray(prev).concat([
                    id
                ]);
            });
            if (selectedIds.length + 1 === ids.length) {
                setIsSelectAll(true);
            }
        } else {
            var updatedSelectedIds = selectedIds.filter(function(itemId) {
                return itemId !== id;
            });
            setSelectedIds(updatedSelectedIds);
            setIsSelectAll(false);
        }
    };
    var handleToggleSelectAllButton = function() {
        if (isSelectAll) {
            setSelectedIds([]);
            setIsSelectAll(false);
        } else {
            var allIds = sort === "character" ? _toConsumableArray(ids) : _toConsumableArray(storyIds);
            setSelectedIds(_toConsumableArray(allIds));
            setIsSelectAll(true);
        }
    };
    var handleToggleEditButton = function() {
        if (sort === "character" ? !ids.length : !(storyIds === null || storyIds === void 0 ? void 0 : storyIds.length)) {
            return;
        }
        if (isEdit) {
            setSelectedIds([]);
            setIsSelectAll(false);
        }
        setIsEdit(!isEdit);
    };
    var handleClickMoveToIntro = function(id) {
        setTimeout(function() {
            if (platform === constants/* Platform.web */.t4.web) {
                router.push("/play/characters/".concat(id));
            } else {
                web.openPage("/play/characters/".concat(id));
            }
        }, 300);
    };
    var handleClickDeleteButton = function() {
        var _ref = _asyncToGenerator(function() {
            var chunkArray, chunkedSelectedIds, updatedIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err, err1;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!confirm("해당 채팅을 삭제하시겠습니까?")) return [
                            3,
                            11
                        ];
                        chunkArray = function(array, chunkSize) {
                            var chunks = [];
                            for(var i = 0; i < array.length; i += chunkSize){
                                chunks.push(array.slice(i, i + chunkSize));
                            }
                            return chunks;
                        };
                        chunkedSelectedIds = chunkArray(selectedIds, 50);
                        updatedIds = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _loop = function() {
                            var chunk, payload;
                            return __generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        chunk = _step.value;
                                        payload = {
                                            chat_room_ids: chunk,
                                            status: "IAT"
                                        };
                                        return [
                                            4,
                                            updateChatRooms(payload, {
                                                onSuccess: function onSuccess() {
                                                    var _updatedIds;
                                                    if (sort === "character") {
                                                        queryClient.removeQueries(queryKey);
                                                    } else {
                                                        queryClient.removeQueries(storyQueryKey);
                                                    }
                                                    (_updatedIds = updatedIds).push.apply(_updatedIds, _toConsumableArray(chunk));
                                                    setIsSelectAll(false);
                                                    setSelectedIds([]);
                                                }
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = chunkedSelectedIds[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        return [
                            5,
                            __values(_loop())
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        firebase.logEvent("chat_room_inactive", {
                            user_id: me === null || me === void 0 ? void 0 : me.id,
                            inactivation_count: selectedIds.length,
                            total_count: ids.length
                        });
                        return [
                            3,
                            11
                        ];
                    case 10:
                        err1 = _state.sent();
                        (0,esm_exports/* captureException */.Tb)(err1);
                        firebase.logEvent("chat_room_inactive", {
                            user_id: me === null || me === void 0 ? void 0 : me.id,
                            inactivation_count: selectedIds.length,
                            total_count: updatedIds.length
                        });
                        return [
                            3,
                            11
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickDeleteButton() {
            return _ref.apply(this, arguments);
        };
    }();
    // const handleClickPromotion = () => {
    //   if (!isOverVersion) {
    //     const text =
    //       platform === Platform.ios
    //         ? 'IOS는 아직 준비중이에요'
    //         : '앱을 최신버전으로 업데이트 해주세요!';
    //     return alert(text);
    //   }
    //   if (platform === Platform.web) {
    //     router.push('/payment?tab=subscription');
    //   }
    //   web.openPage('/payment?tab=subscription');
    // };
    (0,react.useEffect)(function() {
        if (sort === "character") {
            var ref;
            var pages = (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages;
            if (pages) {
                var fetchedIds = pages === null || pages === void 0 ? void 0 : pages.map(function(page) {
                    var ref;
                    return (ref = page.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        return item.id;
                    });
                });
                setIds(fetchedIds === null || fetchedIds === void 0 ? void 0 : fetchedIds.flat());
                setIsSelectAll(false);
            }
        } else {
            var ref1;
            var pages1 = (ref1 = storyQuery.data) === null || ref1 === void 0 ? void 0 : ref1.pages;
            if (pages1) {
                var fetchedIds1 = pages1 === null || pages1 === void 0 ? void 0 : pages1.map(function(page) {
                    var ref;
                    return (ref = page.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        return item.id;
                    });
                });
                setStoryIds(fetchedIds1 === null || fetchedIds1 === void 0 ? void 0 : fetchedIds1.flat());
            }
        }
    }, [
        query.data,
        storyQuery.data,
        sort
    ]);
    (0,react.useEffect)(function() {
        var currentIds = sort === "character" ? ids : storyIds;
        if (!currentIds.length) {
            setIsEdit(false);
        }
        if (selectedIds.length === currentIds.length) {
            setIsSelectAll(true);
        } else {
            setIsSelectAll(false);
        }
    }, [
        selectedIds,
        ids,
        storyIds
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("storage", handleShouldRefreshChange);
        return function() {
            window.removeEventListener("storage", handleShouldRefreshChange);
        };
    }, []);
    var _total_count, ref12;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: readStoryFilterCSS,
                children: [
                    isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Loading/* default */.ZP, {
                        center: true
                    }),
                    !isEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HorizontalFilter/* default */.Z, {
                                options: [
                                    {
                                        label: "전체(".concat((0,misc/* formatComma */.cO)(sort === "character" ? (_total_count = query === null || query === void 0 ? void 0 : (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages[0].total_count) !== null && _total_count !== void 0 ? _total_count : 0 : (ref12 = (ref2 = storyQuery === null || storyQuery === void 0 ? void 0 : (ref1 = storyQuery.data) === null || ref1 === void 0 ? void 0 : ref1.pages[0]) === null || ref2 === void 0 ? void 0 : ref2.total_count) !== null && ref12 !== void 0 ? ref12 : 0), ")"),
                                        value: "latest"
                                    }, 
                                ]
                            }),
                            !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: "sort-container",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HorizontalFilter/* default */.Z, {
                                    options: [
                                        {
                                            label: t("캐릭터"),
                                            value: "character"
                                        },
                                        {
                                            label: t("작품"),
                                            value: "story"
                                        }, 
                                    ],
                                    selected: sort,
                                    onChange: setSort
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HorizontalFilter/* default */.Z, {
                        options: [
                            {
                                label: "선택됨(".concat((0,misc/* formatComma */.cO)(selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.length), ")"),
                                value: "latest"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        css: editButtonGroupCSS,
                        children: [
                            isEdit && hasEditBtn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Fragment, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            css: editButtonCSS,
                                            onClick: handleToggleSelectAllButton,
                                            children: t(isSelectAll ? "전체선택 해제" : "전체선택")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {})
                                ]
                            }),
                            hasEditBtn && (sort === "character" ? query.isFetched : storyQuery === null || storyQuery === void 0 ? void 0 : storyQuery.isFetched) && (sort === "character" ? query.count > 0 : (storyQuery === null || storyQuery === void 0 ? void 0 : storyQuery.count) > 0) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                    css: editButtonCSS,
                                    onClick: handleToggleEditButton,
                                    children: t(isEdit ? "취소" : "편집")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: chatRoomListContainerCSS,
                children: [
                    sort === "character" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                        name: "chat-list",
                        query: query,
                        ad: isAd && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Adfit/* default */.Z, {
                            type: "library"
                        }),
                        inFeedAd: isAd ? inFeedAd : null,
                        children: function(item) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                            if (!(item === null || item === void 0 ? void 0 : item.last_chat_message)) {
                                return;
                            }
                            var regex = /\{\{TextButton\s+link='([^']*)'\s+text='([^']*)'\}\}/;
                            var match = item === null || item === void 0 ? void 0 : (ref = item.last_chat_message) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.match(regex);
                            var lastMessage;
                            if (match) {
                                var _match = _slicedToArray(match, 3), text = _match[2];
                                lastMessage = text;
                            } else {
                                var ref7;
                                lastMessage = (0,chat/* getChatRoomLastMessageContent */.cJ)(item === null || item === void 0 ? void 0 : (ref7 = item.last_chat_message) === null || ref7 === void 0 ? void 0 : ref7.content);
                            }
                            var isAdultChatRoom = !!(item === null || item === void 0 ? void 0 : item.is_sexual);
                            var chatRoominfo = {
                                characterName: item === null || item === void 0 ? void 0 : (ref2 = item.character) === null || ref2 === void 0 ? void 0 : ref2.name,
                                lastMessage: lastMessage,
                                lastMessageDate: item === null || item === void 0 ? void 0 : (ref3 = item.last_chat_message) === null || ref3 === void 0 ? void 0 : ref3.created_at,
                                id: item === null || item === void 0 ? void 0 : item.id,
                                image: item === null || item === void 0 ? void 0 : (ref4 = item.character) === null || ref4 === void 0 ? void 0 : ref4.profile_image,
                                peek: item === null || item === void 0 ? void 0 : item.peek
                            };
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    css: chatRoomListCss,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                                        hideArrow: true,
                                        newTab: true,
                                        left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ChatRoom/* default */.Z, {
                                            chatRoomInfo: chatRoominfo,
                                            isEdit: isEdit,
                                            isCheck: selectedIds.includes(chatRoominfo.id),
                                            isAdultChatRoom: isAdultChatRoom,
                                            isDeletedCharacter: !(item === null || item === void 0 ? void 0 : item.character),
                                            isMyCharacter: (me === null || me === void 0 ? void 0 : me.id) === (item === null || item === void 0 ? void 0 : (ref5 = item.character) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.player) === null || ref6 === void 0 ? void 0 : ref6.user_id)
                                        }, chatRoominfo.id),
                                        onClick: function() {
                                            return isEdit ? handleSelect(chatRoominfo.id) : handleClickContinuteButton(chatRoominfo.id);
                                        }
                                    })
                                }, item.id)
                            });
                        }
                    }),
                    sort === "story" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                        name: "story-chat-list",
                        query: storyQuery,
                        ad: isAd && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Adfit/* default */.Z, {
                            type: "library"
                        }),
                        inFeedAd: isAd ? inFeedAd : null,
                        children: function(item) {
                            var ref, ref1, ref2, ref3, ref4, ref5;
                            if (!(item === null || item === void 0 ? void 0 : item.last_chat_message)) {
                                return;
                            }
                            var lastMessage = (0,chat/* getStoryChatRoomLastMessageContent */.yN)(item === null || item === void 0 ? void 0 : (ref = item.last_chat_message) === null || ref === void 0 ? void 0 : ref.content);
                            var chatRoominfo = {
                                characterName: item === null || item === void 0 ? void 0 : (ref1 = item.episode) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.profile) === null || ref2 === void 0 ? void 0 : ref2.name,
                                lastMessage: lastMessage,
                                lastMessageDate: item === null || item === void 0 ? void 0 : (ref3 = item.last_chat_message) === null || ref3 === void 0 ? void 0 : ref3.created_at,
                                id: item === null || item === void 0 ? void 0 : item.id,
                                image: item === null || item === void 0 ? void 0 : (ref4 = item.episode) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.profile) === null || ref5 === void 0 ? void 0 : ref5.profile_image
                            };
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    css: chatRoomListCss,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                                        hideArrow: true,
                                        newTab: true,
                                        left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(chat_StoryChatRoomCard, {
                                            chatRoomInfo: chatRoominfo,
                                            isEdit: isEdit,
                                            isCheck: selectedIds.includes(chatRoominfo.id),
                                            story: item === null || item === void 0 ? void 0 : item.story
                                        }, chatRoominfo.id),
                                        onClick: function() {
                                            var ref, ref1, ref2;
                                            return isEdit ? handleSelect(chatRoominfo.id) : handleClickContinuteButton(item === null || item === void 0 ? void 0 : item.id, item === null || item === void 0 ? void 0 : (ref = item.episode) === null || ref === void 0 ? void 0 : ref.story_id, item === null || item === void 0 ? void 0 : (ref1 = item.episode) === null || ref1 === void 0 ? void 0 : ref1.episode_id, item === null || item === void 0 ? void 0 : (ref2 = item.story) === null || ref2 === void 0 ? void 0 : ref2.title);
                                        }
                                    })
                                }, item.id)
                            });
                        }
                    }),
                    isEdit && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        css: bottomBtnCSS(isCheming),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(BottomButton/* default */.Z, {
                            className: "bottomButton",
                            text: t("선택 항목 삭제"),
                            onClick: handleClickDeleteButton,
                            disabled: !(selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.length)
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        css: emptyCSS(sort),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Empty/* default */.Z, {
                            query: sort === "character" ? query : storyQuery,
                            hideIcon: sort === "character" ? true : false,
                            className: "empty",
                            children: sort === "character" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: "outlook-container",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                                    name: "play-outlook-list",
                                    query: outlook,
                                    identifier: "key",
                                    children: function(item, index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(OutlookComponent/* default */.Z, {
                                                component: item,
                                                order: index,
                                                onClickProfile: handleClickMoveToIntro
                                            }, index)
                                        });
                                    }
                                })
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                className: "multiline",
                                children: t("작품에서도 플레이 가능한 거, 알고 계셨나요?\n              회차의 마지막에서 플레이할 수 있어요!")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var chat_ChatRoomList = (ChatRoomList);


/***/ }),

/***/ 15822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0;\n\n  .kakao_ad_loaded {\n    box-sizing: content-box;\n    border-top: 8px solid ",
        ";\n    border-bottom: 8px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var adfitCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.border.space, theme.border.space);
};
var Adfit = function(param) {
    var _type = param.type, type = _type === void 0 ? "default" : _type;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var insRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var adIds = {
        default: "DAN-qr8EQ7sjZsy3CDqq",
        story: "DAN-zgHG6SftJMliFZSC",
        library: "DAN-5TSBCtHd9kOfJvtE",
        episodeEnding: "DAN-46N5zb9cg50PxRee"
    };
    // Intersection Observer: 뷰포트 진입 시에만 광고 로드
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!containerRef.current) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = _slicedToArray(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "200px"
        });
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, []);
    // 뷰포트 진입 후 AdFit 스크립트 로드
    var loadAdfit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (!isVisible) return;
        var existing = document.querySelector('script[src*="t1.daumcdn.net/kas/static/ba.min.js"]');
        if (!existing) {
            var script = document.createElement("script");
            script.src = "//t1.daumcdn.net/kas/static/ba.min.js";
            script.async = true;
            script.type = "text/javascript";
            document.body.appendChild(script);
        } else {
            // 스크립트가 이미 있으면 AdFit 재호출
            if (window.adfit && typeof window.adfit === "function") {
                window.adfit("create", {
                    adUnitId: adIds[type],
                    containerElement: insRef.current
                });
            }
        }
    }, [
        isVisible,
        type
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        loadAdfit();
    }, [
        loadAdfit
    ]);
    // MutationObserver: 광고 로드 완료 감지
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!insRef.current || !isVisible) return;
        var observer = new MutationObserver(function() {
            if (insRef.current) {
                insRef.current.className = "kakao_ad_loaded";
                observer.disconnect();
            }
        });
        observer.observe(insRef.current, {
            attributes: true,
            attributeFilter: [
                "style"
            ]
        });
        return function() {
            observer.disconnect();
        };
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        ref: containerRef,
        css: adfitCSS,
        children: isVisible && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ins", {
            ref: insRef,
            className: "kakao_ad_area",
            style: {
                display: "none"
            },
            "data-ad-unit": adIds[type],
            "data-ad-width": "320",
            "data-ad-height": "50"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Adfit);


/***/ }),

/***/ 61507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77814);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  button {\n    font-size: ",
        "px;\n    color: ",
        ";\n\n    &.active {\n      color: ",
        ";\n    }\n  }\n\n  span {\n    display: inline-block;\n    height: 12px;\n    border-left: 1px solid ",
        ";\n    margin: 0 ",
        "px;\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var horizontalFilterCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .FontSizes.xsmall */ .TS.xsmall, theme.var.gray500, theme.var.black, theme.border.light, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xsmall */ .Ki.xsmall);
};
var HorizontalFilter = function(param) {
    var options = param.options, selected = param.selected, onChange = param.onChange;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        css: horizontalFilterCSS,
        children: options.map(function(option, i) {
            /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    i > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("button", {
                        onClick: function() {
                            return onChange === null || onChange === void 0 ? void 0 : onChange(option.value);
                        },
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(option.value === selected ? "active" : undefined, "text-btn"),
                        children: option.label
                    })
                ]
            }, "horizontal-filter-".concat(option.value));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HorizontalFilter);


/***/ }),

/***/ 92626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "av": function() { return /* binding */ CrownRank; },
/* harmony export */   "nf": function() { return /* binding */ LinkItem; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71618);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82740);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60186);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30259);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81946);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    cursor: pointer;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 28px;\n  text-align: center;\n  margin-right: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  min-width: 0;\n\n  h6 + small,\n  small + small {\n    display: block;\n    ",
        ";\n    margin-top: ",
        "px;\n    color: ",
        ";\n  }\n\n  small + small {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        "px;\n  width: 32px;\n  font-size: ",
        "px;\n  text-align: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









var listItemCSS = function(isClickable) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject1(), isClickable && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject()));
};
var rankSectionCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject2(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium);
var leftSectionCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject3(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body12 */ .ZT.body12, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall, theme.var.gray500, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xxsmall */ .Ki.xxsmall);
};
var rightSectionCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject4());
var ListItem = function(param) {
    var className = param.className, rank = param.rank, left = param.left, right = param.right, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        css: listItemCSS(!!onClick),
        className: className,
        onClick: onClick,
        children: [
            rank && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                css: rankSectionCSS,
                children: rank
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                css: leftSectionCSS,
                children: left
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                css: rightSectionCSS,
                children: right
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (ListItem);
var linkItemRightCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject5(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body12 */ .ZT.body12);
var LinkItem = function(param) {
    var to = param.to, _hideArrow = param.hideArrow, hideArrow = _hideArrow === void 0 ? false : _hideArrow, newTab = param.newTab, legacy = param.legacy, rank = param.rank, left = param.left, right = param.right, className = param.className, onClick = param.onClick;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    var ref = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_6__/* .useWebView */ .B9)(), web = ref.web, openLegacyPageSafe = ref.openLegacyPageSafe;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)().platform;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!to) {
            return;
        }
        if (platform !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .Platform.web */ .t4.web) {
            if (newTab) {
                web.openPage(to);
            } else if (legacy) {
                openLegacyPageSafe(to);
            } else {
                router.push(to);
            }
        } else {
            router.push(to);
        }
    }, [
        to,
        legacy
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(ListItem, {
        rank: rank,
        left: left,
        right: (to || onClick) && !hideArrow ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            css: linkItemRightCSS,
            children: [
                right,
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                    icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRight */ .ol,
                    size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small,
                    color: theme.var.gray500
                })
            ]
        }) : right,
        onClick: to ? handleClick : onClick,
        className: className
    });
};
var crownRankCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject6(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .FontSizes.medium */ .TS.medium);
var CrownRank = function(param) {
    var rank = param.rank;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        css: crownRankCSS,
        "data-test": "Crown",
        children: rank <= 3 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
            icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Crown */ ._O,
            color: rank === 1 ? theme.colors.yellow400 : rank === 2 ? "#c3ced1" : "#e5926f",
            size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.large */ .u8.large
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h5", {
            children: rank
        })
    });
};


/***/ })

}]);